import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FiMenu, FiX } from 'react-icons/fi';
import { logoutUser, stopImpersonation } from '../store/authSlice';
import toast from 'react-hot-toast';
import styles from './DashboardHeader.module.css';

/**
 * Dashboard header with user info and logout.
 */
function DashboardHeader({ onToggleSidebar, mobileSidebarOpen = false }) {
  const dispatch = useDispatch();
  const { user, impersonation } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  const handleStopImpersonation = async () => {
    try {
      await dispatch(stopImpersonation()).unwrap();
      toast.success('Returned to admin account');
    } catch (errorMessage) {
      toast.error(errorMessage || 'Failed to stop impersonation');
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <button
            type="button"
            className={styles.mobileMenuBtn}
            onClick={onToggleSidebar}
            aria-label={mobileSidebarOpen ? 'Close dashboard menu' : 'Open dashboard menu'}
            aria-expanded={mobileSidebarOpen ? 'true' : 'false'}
          >
            {mobileSidebarOpen ? <FiX /> : <FiMenu />}
          </button>
          <Link to="/dashboard" className={styles.logo}>
            <img src="/digitized-menu-logo.svg" alt="digitizedmenu.com" className={styles.logoImage} />
          </Link>
        </div>
        <div className={styles.right}>
          {impersonation?.is_active && (
            <button onClick={handleStopImpersonation} className="btn btn-secondary btn-sm">
              Exit User View
            </button>
          )}
          <span className={styles.plan}>
            {user?.plan?.name || 'Free'} Plan
          </span>
          <Link to="/profile" className={styles.user} title="My Profile">
            <span className={styles.avatar}>
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
            <span className={styles.name}>{user?.name}</span>
          </Link>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Log out
          </button>
        </div>
      </div>
    </header>
  );
}

export default DashboardHeader;
